export default {
  value: 'subscription_plans',
  label: 'Subscription Plans',
};
